import type { ProximityContact } from '../../simulation/CollisionQueries';
import { findBehavior, type ReactiveBehaviorType } from '../../world/SurfaceMaterials';

/**
 * Strength multiplier an experiment applies at a nearby surface: the
 * material's matching reactive behaviour strength, or `allSurfaces` for any
 * other non-lethal solid (0 by default, so experiments only act where the
 * level designer placed the matching reactive material).
 */
export function surfaceStrength(c: ProximityContact, type: ReactiveBehaviorType, allSurfaces: number): number {
  const m = c.material;
  if (!m || m.kind === 'lethal' || m.kind === 'trigger') return 0;
  const b = findBehavior(m, type);
  if (b && 'strength' in b) return b.strength;
  return allSurfaces;
}

/** Proximity falloff: 1 at contact, 0 at `range`, quadratic. */
export function proximityWeight(distance: number, range: number): number {
  const t = 1 - Math.max(0, distance) / range;
  return t <= 0 ? 0 : t * t;
}
